import { render, staticRenderFns } from "./RelatorioLogHabilidade.vue?vue&type=template&id=4021e55e&scoped=true"
import script from "./RelatorioLogHabilidade.vue?vue&type=script&lang=js"
export * from "./RelatorioLogHabilidade.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogHabilidade.vue?vue&type=style&index=0&id=4021e55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021e55e",
  null
  
)

export default component.exports